import * as yup from 'yup';

export const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
const pincodeRegex = /^\d{6}$/;

const pincode = yup.string().matches(pincodeRegex, {
  message: 'Pincode must be exactly 6 digits',
  excludeEmptyString: true,
});

const optionalGstin = yup.string().matches(gstinRegex, {
  message: 'Invalid GSTIN format',
  excludeEmptyString: true,
});

const optionalPan = yup.string().matches(panRegex, {
  message: 'Invalid PAN format',
  excludeEmptyString: true,
});

export const directoryValidationSchema = yup.object().shape({
  clientName: yup.string().trim().required('Name is required'),
  email: yup.string().email('Invalid email format'),
  phone: yup.string(),
  address1: yup.string(),
  address2: yup.string(),
  state: yup.string(),
  country: yup.string(),
  pincode,
  gstin: optionalGstin,
  pan: optionalPan,
  // Free-text referral source. Declared here (rather than only on the pages'
  // FormData type) so the resolver's inferred type still matches FormData —
  // omitting it makes yupResolver unassignable to Resolver<FormData>.
  reference_name: yup.string(),
  branchDetails: yup.array().of(
    yup.object().shape({
      branchName: yup.string(),
      gstin: optionalGstin,
      address1: yup.string(),
      address2: yup.string(),
      pincode,
      state: yup.string(),
      country: yup.string(),
    }),
  ),
});
